import {Component, ElementRef, Injector, OnInit, Renderer2, ViewChild} from '@angular/core';
import {UserService} from '../services/user.service';
import {Router} from '@angular/router';
import {PomodoroRepository} from '../Models/PomodoroRepository';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  // @ViewChild('toggleButton') toggleButton: ElementRef;
  // @ViewChild('menu') menu: ElementRef;
  @ViewChild('hello', { static: false }) divHello: ElementRef<HTMLInputElement>;
  public isMenuOpen = false;
  public showMobile = false;
    public userIsLoggedIn;
    public login = 'ورود';
    public profile = 'پروفایل';
    public clickToggle = false;
  public pomodoroRepository: PomodoroRepository;
  constructor(private userService: UserService,
              private router: Router,
              injector: Injector) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }

  ngOnInit(): void {
    const token = localStorage.getItem('token');
    if (token !== null) {
      this.userIsLoggedIn = true;
      this.login = 'خروج';
    } else {
      this.userIsLoggedIn = false;
      this.login = 'ورود';
    }
  }
  logOut(): any{
    this.pomodoroRepository.prevLang = localStorage.getItem('trans');
    localStorage.clear();
    localStorage.setItem('trans', this.pomodoroRepository.prevLang);
    this.userIsLoggedIn = false;
    this.userService.logOut();
    this.router.navigateByUrl('/').then( () => {
      location.reload();
    });
  }
  openMenu(): any{
    this.showMobile = true;
  }
  closeMenu(): any{
    this.showMobile = false;
  }
  toggleMenu(): any {
    this.isMenuOpen = !this.isMenuOpen;
  }
}
